import type from './type.js';

export default (args) => {
    if (args.length < 2) return null;
    const l = args.length - 1;
    if (type(args[l]) == 'string') return args[l].toLowerCase();
    return null;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/utils/last.js
// module id = 2493
// module chunks = 6